@if (interactive()) {
  <odl-button [id]="buttonId" [class.selected]="selected()" [description]="description()">
    <div class="dot" slot="only-icon"></div>
  </odl-button>
  <odl-tooltip [for]="'#' + buttonId">{{ description() }}</odl-tooltip>
} @else {
  <div class="dot" [class.selected]="selected()"></div>
}
